<template>
  <div class="container">
    <div class="main-content">
      <!-- 批量定时区域 -->
      <div class="batch-time-setting">
        <el-card class="time-card">
          <div class="stage-tags">
            <el-tag
              style="width: 100%;height: 40px;"
              v-for="stage in timeStages"
              :key="stage.id"
              :type="activeStage && activeStage.id === stage.id ? 'success' : ''"
              closable
              @click="selectStage(stage)"
              @close="removeStage(stage)"
              @contextmenu.native.prevent="handleStageRightClick(stage, $event)"
            >
              {{ formatStageTime(stage) }}({{ stage.pindao==1?"特价秒杀":"半价秒杀" }})
            </el-tag>
            <el-button 
              type="primary" 
              icon="el-icon-plus" 
              size="mini" 
              style="width: 100%;"
              @click="addNewStage"
            >
              新增阶段
            </el-button>
          </div>
        </el-card>
      </div>

      <!-- 原有内容 -->
      <div class="content-right">
        <!-- 筛选查询 -->
        <div class="wML-screen">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>筛选查询</span>
            </div>
            <div class="wMLS-list">
              <el-form label-position="left" label-width="90px" :model="wScreen">
                <el-row :gutter="24">
                  <el-col :span="6">
                    <el-form-item label="关键字">
                      <el-input 
                        style="width: 100%;" 
                        type="text" 
                        v-model="wScreen.search" 
                        placeholder="请输入关键字" 
                        clearable
                        @input="changeInputSearch"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="店铺名称" prop="storeId">
                      <el-select 
                        v-model="wScreen.storeId" 
                        placeholder="请选择店铺" 
                        :clearable="clearableStoreId"
                        :disabled="disabledStoreId" 
                        @change="changeSelectStoreId" 
                        style="width: 100%;"
                      >
                        <el-option 
                          v-for="item in optionsStore" 
                          :key="item.value" 
                          :label="item.label"
                          :value="item.value" 
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="商品分类">
                      <el-select 
                        v-model="wScreen.categoryId" 
                        :placeholder="placeholderCategory" 
                        clearable
                        :disabled="disabledCategory" 
                        @change="changeSelectCategory" 
                        style="width: 100%;"
                      >
                        <el-option 
                          v-for="item in optionsCategory" 
                          :key="item.value" 
                          :label="item.label"
                          :value="item.value" 
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="商品状态">
                      <el-select 
                        v-model="wScreen.state" 
                        placeholder="请选择状态" 
                        clearable 
                        @change="changeSelectState"
                        style="width: 100%;"
                      >
                        <el-option 
                          v-for="item in optionsState" 
                          :key="item.value" 
                          :label="item.label" 
                          :value="item.value" 
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              
              <el-row type="flex" justify="space-between">
                <el-col :span="20">
                  <el-button size="medium" @click="resetwScreen" v-if="showView">重置</el-button>
                  <el-button size="medium" @click="submitwScreen">查询</el-button>
                </el-col>
                <div>
                  <el-button type="primary" @click="addGoods" v-if="showView">添加商品</el-button>
                </div>
              </el-row>
            </div>
          </el-card>
        </div>

        <!-- 商品列表区域 -->
        <div class="wGoodsList-area">
          <div class="wGL-goods">
            <div class="wGLG-table">
              <el-table :data="tableGoods" border style="width: 100%;">
                <el-table-column label="商品名称" prop="name"></el-table-column>
                <el-table-column label="商品分类" prop="categoryId" align="center" width="140">
                  <template slot-scope="scope">
                    <div v-for="item in goodsCategory" :key="item.value" v-if="scope.row.categoryId == item.value">
                      {{ item.label }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品类型" align="center" width="140">
                  <template slot-scope="scope">
                    <div v-for="item in goodsType" :key="item.value" v-if="scope.row.atype == item.value">
                      {{ item.label }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="店铺" prop="storeId">
                  <template slot-scope="scope">
                    <div v-for="item in optionsStore" :key="item.value" v-if="scope.row.storeId == item.value">
                      {{ item.label }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="图片" width="100" align="center">
                  <template slot-scope="scope">
                    <template v-if="isImage(scope.row.headImg[0])">
                      <el-image
                        style="width:80px;height:80px;"
                        fit="contain"
                        :src="scope.row.headImg[0]"
                        :preview-src-list="[scope.row.headImg]"
                      ></el-image>
                    </template>
                    <template v-else-if="isVideo(scope.row.headImg[0])">
                      <video
                        muted
                        autoplay="autoplay"
                        loop="loop"
                        style="width:80px;height:80px;"
                        fit="contain"
                        :src="scope.row.headImg[0]"
                        :preview-src-list="[scope.row.headImg]"
                      ></video>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column label="价格" prop="retailPrice" width="140" align="center"></el-table-column>
                <el-table-column label="运费" prop="freight" width="140" align="center"></el-table-column>
                <el-table-column label="销量" prop="sales" width="140" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sales">{{ scope.row.sales }}</span>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
                <el-table-column label="排序" prop="sort" width="140" align="center"></el-table-column>
                <el-table-column label="限购数量" width="140" align="center">
                  <template slot-scope="scope" v-if="scope.row.atype == 16">
                    <el-input v-model="scope.row.groupHotSaleNum" :disabled="true" v-if="scope.row.isGroupHotSale" />
                    <el-input v-model="scope.row.groupHotSaleNum" type="number" :min="0" placeholder="请设置数量" v-else />
                  </template>
                </el-table-column>
                <el-table-column label="限购" align="center" width="140">
                  <template slot-scope="scope"
                    v-if="scope.row.atype == 16 && (scope.row.groupHotSaleNum && scope.row.groupHotSaleNum >= 1)">
                    <el-switch 
                      v-model="scope.row.isGroupHotSale" 
                      :active-value="1" 
                      :inactive-value="0"
                      :active-text="scope.row.isGroupHotSale ? '开启' : '关闭'" 
                      @change="changeIsGroupHotSale(scope)" 
                    />
                  </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="140">
                  <template slot-scope="scope">
                    <el-switch 
                      v-model="scope.row.state" 
                      :active-value="1" 
                      :inactive-value="0"
                      :active-text="scope.row.state ? '已上架' : '已下架'" 
                      @change="changeGoodsState(scope)" 
                    />
                  </template>
                </el-table-column>
                <!-- <el-table-column label="半价秒杀状态" width="180" align="center">
                  <template slot-scope="scope">
                    <el-tag 
                      :type="getBanjiaStatus(scope.row) == '进行中' ? 'success' : 
                            getBanjiaStatus(scope.row) == '未开始' ? 'warning' : 'info'"
                    >
                      {{ getBanjiaStatus(scope.row) }}
                    </el-tag>
                    <div v-if="getBanjiaStatus(scope.row) !== '-'" style="margin-top: 5px; font-size: 12px;">
                      {{ scope.row.startTime }}<br>
                      时长: {{ scope.row.during }}分钟
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column label="操作" align="center" width="140" v-if="showView">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="updateGoods(scope)"><span>修改</span></el-button>
                    <el-button type="text" size="small" @click="deleteGoods(scope)"><span>删除</span></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <!-- 分页 -->
            <div class="wPagination">
              <el-pagination 
                @current-change="changePaginationCurrent" 
                @size-change="changePaginationSize"
                :current-page="pagination.current" 
                :page-sizes="pagination.sizes" 
                :page-size="pagination.size"
                :total="pagination.total" 
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加/编辑商品对话框 -->
    <el-dialog 
      width="1000px" 
      append-to-body 
      :title="title" 
      :visible.sync="visibleAddGoods"
      :close-on-press-escape="false" 
      :close-on-click-modal="false"
    >
      <!-- 原有对话框内容保持不变 -->
      <el-form :rules="rulesAddGoods" ref="formAddGoods" :model="formAddGoods" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品类型" prop="atype">
              <el-select 
                v-model="formAddGoods.atype" 
                placeholder="请选择商品类型" 
                @change="changeSupplyCategory" 
                clearable
                style="width: 100%;"
              >
                <el-option 
                  v-for="(item, index) in goodsType" 
                  :key="item.value" 
                  :label="item.label"
                  :value="item.value" 
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在门店" prop="storeId">
              <el-select 
                v-model="formAddGoods.storeId" 
                placeholder="请选择门店" 
                clearable 
                @change="changeSelectStoreId"
                style="width: 100%;"
              >
                <el-option 
                  v-for="(item, index) in optionsStore" 
                  :key="item.value" 
                  :label="item.label"
                  :value="item.value" 
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品原价" prop="bidPrice">
              <el-input 
                v-model="formAddGoods.bidPrice" 
                type="number" 
                placeholder="请输入商品售价" 
                maxlength="8"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品售价" prop="retailPrice">
              <el-input 
                v-model="formAddGoods.retailPrice" 
                type="number" 
                placeholder="请输入商品售价" 
                maxlength="8"
              />
            </el-form-item>
          </el-col>
          
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品名称" prop="name">
              <el-input 
                v-model="formAddGoods.name" 
                type="text" 
                placeholder="请输入商品名称" 
                maxlength="30"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品序号" prop="sort">
              <el-input 
                v-model="formAddGoods.sort" 
                type="number" 
                placeholder="请输入商品序号" 
                maxlength="8"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整体排序" prop="sort">
              <el-input v-model="formAddGoods.reorder" type="number" placeholder="请输入排序" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="描述" prop="brand">
              <el-input v-model="formAddGoods.brand" type="text" placeholder="请输入描述"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                v-model="formAddGoods.startTime"
                type="datetime"
                placeholder="选择秒杀开始时间"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抢购时长" prop="during">
              <el-input 
                v-model="formAddGoods.during" 
                type="number" 
                placeholder="请输入抢购时长(分钟)"
                min="1"
              />
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商品规格" prop="unit" v-for="(item,i) in unnits" :key="i">
              <div class="unitBox">
                <div class="unitTop">
                  <el-input 
                    v-model="item.unitNum" 
                    type="text" 
                    placeholder="请输入规格" 
                    style="width:388px"
                    class="input"
                  />
                  <el-select 
                    v-model="item.unit" 
                    placeholder="请选择或输入单位" 
                    class="input"
                    style="width:200px"
                    filterable
                    allow-create
                    reserve-keyword
                  >
                    <el-option 
                      v-for="(item, index) in optionsUnits" 
                      :key="item.index" 
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  
                  <div class="goodsItem">
                    <span class="span spankc">库存</span>
                    <el-input  
                      class="input inputprice" 
                      v-model="item.stock" 
                      type="number"  
                      maxlength="8"
                      style="width: 97px;"
                    />
                  </div>
                </div>
                
                <div class="unitBottom">
                  <div class="pricebox">
                    <!-- <div class="goodsItem">
                      <span class="span">顾客价</span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.price" 
                        type="number"  
                        maxlength="8"
                      />
                    </div>
                    <div class="goodsItem">
                      <span class="span">会员价</span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.membershipPrice" 
                        type="number"  
                        maxlength="8"
                      />
                    </div>
                    <div class="goodsItem">
                      <span class="span">VIP价</span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.vipPrice" 
                        type="number" 
                        maxlength="8"
                      />
                    </div>
                    <div class="goodsItem">
                      <span class="span">轻创价</span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.qcPrice" 
                        type="number"
                        maxlength="8"
                      />
                    </div>
                    <div class="goodsItem">
                      <span class="span">社区团长价</span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.communityLeaderPrice" 
                        type="number"  
                        maxlength="8"
                      />
                    </div> -->
                  </div>
                  <el-button 
                    class="but butdel"
                    @click="reduce(i)"
                    v-if="i>=1"
                  >
                    - 删除
                  </el-button>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商品简介" prop="details">
              <quill-editor
                ref="quillEditor"
                v-model="formAddGoods.details"
                :options="editorOptions"
                style="height: 200px; margin-bottom: 100px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="0">
          <el-col :span="24">
            <el-form-item label-width="0">
              <div class="goods-attr-line">
                <span class="attr-label">七天无理由退货</span>
                <el-checkbox v-model="formAddGoods.noreason" :true-label="1" :false-label="0"></el-checkbox>
                <span class="attr-label">品质严保</span>
                <el-checkbox v-model="formAddGoods.prem" :true-label="1" :false-label="0"></el-checkbox>
                <span class="attr-label">急速退款</span>
                <el-checkbox v-model="formAddGoods.instantrefund" :true-label="1" :false-label="0"></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="配送" prop="freight">
                <el-radio-group v-model="freightValue" >
                    <el-radio label="z">自提</el-radio>
                    <el-radio label="w">快递</el-radio>
                    <el-radio label="a">均可以</el-radio>
                </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="freightValue=='w' || freightValue=='a'">
          <el-col :span="12">
            <el-form-item label="运费金额" prop="freight">
              <el-input 
                v-model="formAddGoods.freight" 
                type="number" 
                placeholder="请输入运费" 
                maxlength="30"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="销售佣金">
              <el-input 
                v-model="formAddGoods.salecomm" 
                placeholder="销售佣金" 
                maxlength="50"
                class="input"
                type="number"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国补折扣">
              <el-input 
                v-model="formAddGoods.discount" 
                placeholder="国补折扣" 
                maxlength="50"
                class="input"
                type="number"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="公司分佣">
              <el-input 
                v-model="commission" 
                placeholder="软件公司分佣" 
                maxlength="50"
                class="input"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col>
            <el-form-item label="商品主图" prop="headImg">
              <el-upload 
                ref="mainUpload" 
                list-type="picture-card" 
                :limit="limitMainImg" 
                :file-list="mainFileList"
                :class="{ hide: hideMainUpload }" 
                :action="getUploadUrl()" 
                :before-upload="uploadBefore"
                :on-success="uploadSuccessMain" 
                :on-remove="uploadRemoveMain" 
                :show-file-list="true"
              >
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]"
                    />
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url"
                    />
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'zt')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col>
            <el-form-item label="商品配图">
              <el-upload 
                ref="nextUpload" 
                list-type="picture-card" 
                :limit="limitNextImg" 
                :file-list="nextFileList"
                :class="{ hide: hideNextUpload }" 
                :action="getUploadUrl()" 
                :before-upload="uploadBefore"
                :on-success="uploadSuccessNext" 
                :on-remove="uploadRemoveNext" 
                :show-file-list="true"
              >
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]"
                    />
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url"
                    />
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'pt')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAddGoods = false">取 消</el-button>
        <el-button type="primary" @click="submitAddGoods('formAddGoods')">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增定时阶段" :visible.sync="showAddStageDialog" :modal="false" width="500px">
      <el-form :model="newStageForm" label-width="100px">
        <el-form-item label="开始时间" required>
          <el-date-picker
            v-model="newStageForm.startTime"
            type="datetime"
            placeholder="选择秒杀开始时间"
            style="width: 100%;"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="抢购时长(分钟)" required>
          <el-input-number 
            v-model="newStageForm.during" 
            :min="1" 
            :max="1440"
            :controls="false"
          />
        </el-form-item>
        <el-form-item label="选择频道" required>
                  <el-select 
                    v-model="newStageForm.pindao" 
                    placeholder="请选择频道" 
                    class="input"
                    style="width:200px"
                  >
                    <el-option 
                      v-for="(item, index) in optionsPindao" 
                      :key="item.index" 
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddStageDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmAddStage">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑时段对话框 -->
    <el-dialog title="编辑定时阶段" :visible.sync="showEditStageDialog" :modal="false" width="500px">
      <el-form :model="editStageForm" label-width="100px">
        <el-form-item label="开始时间" required>
          <el-date-picker
            v-model="editStageForm.startTime"
            type="datetime"
            placeholder="选择秒杀开始时间"
            style="width: 100%;"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="抢购时长(分钟)" required>
          <el-input-number 
            v-model="editStageForm.during" 
            :min="1" 
            :max="1440"
            :controls="false"
          />
        </el-form-item>
        <el-form-item label="选择频道" required>
          <el-select 
            v-model="editStageForm.pindao" 
            placeholder="请选择频道" 
            class="input"
            style="width:200px"
          >
            <el-option 
              v-for="(item, index) in optionsPindao" 
              :key="item.index" 
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditStageDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmEditStage">确定</el-button>
      </span>
    </el-dialog>

    <!-- 右键菜单 -->
    <div 
      v-if="showContextMenu" 
      class="context-menu"
      :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }"
      @click.stop
      @contextmenu.stop.prevent
    >
      <div class="context-menu-item" @click="editStageFromMenu">
        <i class="el-icon-edit"></i>
        <span>编辑时段</span>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassify, getSupplyOptions } from "@/network/api.js";
import { goods_GCEditGoods, goods_GCAddGoods, goods_GCRemoveGoodsById, 
         goods_GCGetGoodsInfo, pub_fileUpload_file, changeGroupHotSaleApi,getDuringTime,addDuringTime,deleteDuringTime } from '@/network/wApi';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from 'moment';
import { editTime } from "../../network/api";

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      // 新增的数据
      timeStages: [], // 所有定时阶段
      activeStage: null, // 当前选中的阶段索引
      batchTime: { // 批量定时设置
        startTime: null,
        during: null
      },
      showAddStageDialog: false, // 是否显示新增阶段对话框
      newStageForm: { // 新增阶段表单
        startTime: null,
        during: null,
        pindao:1
      },
      showContextMenu: false, // 是否显示右键菜单
      contextMenuX: 0, // 右键菜单X坐标
      contextMenuY: 0, // 右键菜单Y坐标
      selectedStageForMenu: null, // 右键选中的时段
      showEditStageDialog: false, // 是否显示编辑时段对话框
      editStageForm: { // 编辑时段表单
        id: null,
        startTime: null,
        during: null,
        pindao: 1
      },
      
      // 原有数据
      commission: '',
      wScreen: {
        search: null,
        categoryId: null,
        state: null,
        storeId: null,
        goodType: 2
      },
      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            handlers: {
              video: this.handleVideoUpload.bind(this)
            }
          }
        },
        placeholder: '请输入商品简介...',
        theme: 'snow'
      },
      optionsStore: [],
      clearableStoreId: true,
      disabledStoreId: false,
      optionsCategory: [],
      placeholderCategory: "请先选择商品类型和门店",
      disabledCategory: true,
      optionsState: [
        { label: "全部", value: "" }, 
        { label: "已上架", value: "1" }, 
        { label: "未上架", value: "0" }
      ],
      optionsPindao:[
        { label: "特价秒杀", value: 1 }, 
        { label: "半价秒杀", value: 2 }, 
      ],
      goodsType: [],
      goodsCategory: [],
      tableGoods: [],
      pagination: {
        current: 1,
        size: 20,
        sizes: [10, 20, 50, 100],
        total: 0,
      },
      title: "",
      visibleAddGoods: false,
      visibleSupply: false,
      formAddGoods: {
        storeId: "",
        categoryId: "",
        name: "",
        retailPrice: "",
        atype: "",
        sort: "",
        reorder: null,
        brand: "",
        unit: "",
        details: "",
        bidPrice:null,
        headImg: "",
        skuList: null,
        imgList: [],
        freight: 0,
        salecomm: 0,
        discount: 0,
        noreason: 0,
        prem: 0,
        instantrefund: 0,
        isExplosiveProducts: 0,
        isBanjiaProducts: 0,
        isVipFreeProducts: 0,
        topPrice: null,
        goodType: 2,
        decsPrice: null,
        startTime: null,
        during: null
      },
      freightValue: "z",
      commission: "",
      onShowSkuList: false,
      rulesAddGoods: {
        storeId: [{ required: true, message: '请选择所属门店', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入商品售价', trigger: 'blur' }],
        atype: [{ required: true, message: '请选择商品类型', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入商品排序', trigger: 'blur' }],
        headImg: [{ required: true, message: '请上传商品主图', trigger: 'blur' }],
        startTime: [
          { 
            required: true, 
            message: '请选择秒杀开始时间', 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.formAddGoods.isBanjiaProducts && !value) {
                callback(new Error('请选择秒杀开始时间'));
              } else {
                callback();
              }
            }
          }
        ],
        during: [
          { 
            required: true, 
            message: '请输入抢购时长', 
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (this.formAddGoods.isBanjiaProducts && !value) {
                callback(new Error('请输入抢购时长'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      optionsUnits: [
        { label: "份", value: "份" },
        { label: "位", value: "位" },
        { label: "锅", value: "锅" },
        { label: "碗", value: "碗" },
        { label: "盒", value: "盒" },
        { label: "条", value: "条" },
        { label: "根", value: "根" },
        { label: "盘", value: "盘" },
        { label: "桶", value: "桶" },
        { label: "包", value: "包" },
        { label: "袋", value: "袋" },
        { label: "件", value: "件" },
        { label: "箱", value: "箱" },
        { label: "罐", value: "罐" },
        { label: "瓶", value: "瓶" },
        { label: "吨", value: "吨" },
        { label: "斤", value: "斤" },
        { label: "两", value: "两" },
        { label: "克", value: "克" },
        { label: "升", value: "升" },
        { label: "串", value: "串" },
      ],
      unitNum: 1,
      goodsUnit: "份",
      mainFileList: [],
      limitMainImg: 5,
      hideMainUpload: false,
      nextFileList: [],
      limitNextImg: 4,
      hideNextUpload: false,
      showView: false,
      disabledGoods: true,
      unnits: [
        {
          membershipPrice: 0,
          vipPrice: 0,
          qcPrice: 0,
          communityLeaderPrice: 0,
          price: 0,
          unitNum: "",
          stock: "",
          unit: "",
        }
      ]
    };
  },
  created() {
    this.changePermission();
    this.loadTimeStages();
    document.addEventListener('click', this.hideContextMenu);
    document.addEventListener('contextmenu', this.hideContextMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideContextMenu);
    document.removeEventListener('contextmenu', this.hideContextMenu);
  },
  methods: {
    // 新增的方法 - 右键菜单和编辑时段
    handleStageRightClick(stage, event) {
      this.showContextMenu = false;
      this.selectedStageForMenu = stage;
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      setTimeout(() => {
        this.showContextMenu = true;
      }, 10);
    },

    hideContextMenu(event) {
      if (this.showContextMenu) {
        const contextMenu = document.querySelector('.context-menu');
        if (contextMenu && !contextMenu.contains(event.target)) {
          this.showContextMenu = false;
        }
      }
    },

    editStageFromMenu() {
      this.showContextMenu = false;
      this.editStageForm = {
        id: this.selectedStageForMenu.id,
        startTime: this.selectedStageForMenu.startTime,
        during: this.selectedStageForMenu.during,
        pindao: this.selectedStageForMenu.pindao || 1
      };
      this.showEditStageDialog = true;
    },

    async confirmEditStage() {
      if (!this.editStageForm.startTime || !this.editStageForm.during || !this.editStageForm.pindao) {
        this.$message.warning('请填写完整的定时信息');
        return;
      }

      try {
        console.log(this.editStageForm);
        
        await editTime(this.editStageForm);
        this.$message.success('时段更新成功');
        this.showEditStageDialog = false;
        await this.loadTimeStages();
      } catch (error) {
        console.error('编辑时段失败:', error);
        this.$message.error('编辑时段失败');
      }
    },

    formatStageTime(stage) {
      if (!stage.startTime || !stage.during) return '未设置时间';
      const start = new Date(stage.startTime);
      const end = new Date(start.getTime() + stage.during * 60 * 1000);
      return `${moment(start).format('MM-DD HH:mm')} ~ ${moment(end).format('HH:mm')}`;
    },
    
    // 加载所有定时阶段
    async loadTimeStages() {
      // 这里应该调用API获取所有定时阶段
      // 模拟数据

      if (this.timeStages.length > 0) {
        this.activeStage = 0;
      }
      let res=await getDuringTime();
      console.log(res);
      
      this.timeStages = res
    },
    
    // 选择定时阶段
    selectStage(stage) {
      this.activeStage = stage;
        this.submitwScreen()
    },
    // 加载阶段商品数据
     loadStageGoods(stage) {
        this.tableGoods = null;
        this.pagination.total = null;
      this.$api.goods_GCList({
        data: {
          timeId: this.activeStage.id,
          goodType:2,
          "pageModel.pageNo": this.pagination.current,
          "pageModel.pageSize": this.pagination.size
        },
        success: res => {
          this.tableGoods = res.records;
          console.log(this.tableGoods);
          
          this.pagination.total = res.total;
        },
        error: err => {
          console.error('加载商品失败:', err);
          this.$message.error('加载商品失败');
        }
      });
    },
    
    // 删除定时阶段
     async removeStage(stage) {
      try {
        await this.$confirm('确定删除这个定时阶段吗?', '提示', {
          type: 'warning'
        });
        
        await deleteDuringTime(stage.id);
        this.$message.success('定时阶段已删除');
        
        // 重新加载阶段
        await this.loadTimeStages();
        
        // 如果删除的是当前选中的阶段，重置选中状态
        if (this.activeStage && this.activeStage.id === stage.id) {
          this.activeStage = this.timeStages.length > 0 ? this.timeStages[0] : null;
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除定时阶段失败:', error);
          this.$message.error('删除定时阶段失败');
        }
      }
    },
    
    // 添加新定时阶段
    addNewStage() {
      console.log(this.timeStages);
      
      if(this.timeStages.length==8){
        this.$message.warning("最多只能设置四个时间段")
        return
      }
      this.newStageForm = {
        startTime: null,
        during: null,
        pindao:1
      };
      this.showAddStageDialog = true;
    },
    
    // 保存当前批量设置为新阶段
    saveCurrentStage() {
      if (!this.batchTime.startTime || !this.batchTime.during) {
        this.$message.warning('请先设置批量定时');
        return;
      }
      
      const newStage = {
        startTime: this.batchTime.startTime,
        during: this.batchTime.during
      };
      
      // 检查是否已存在相同时间的阶段
      const exists = this.timeStages.some(stage => 
        stage.startTime === newStage.startTime && 
        stage.during === newStage.during
      );
      
      if (exists) {
        this.$message.warning('已存在相同时间的定时阶段');
        return;
      }
      
      this.timeStages.push(newStage);
      // this.activeStage = this.timeStages.length - 1;
      this.$message.success('定时阶段已保存');
    },
    
    // 确认添加新阶段
    async confirmAddStage() {
      if (!this.newStageForm.startTime || !this.newStageForm.during|| !this.newStageForm.pindao) {
        this.$message.warning('请填写完整的定时信息');
        return;
      }
      
      try {
        const param = {
          during: this.newStageForm.during,
          startTime: this.newStageForm.startTime,
          pindao:this.newStageForm.pindao
        };
        console.log(param);
        
        await addDuringTime(param);
        this.showAddStageDialog = false;
        this.$message.success('定时阶段添加成功');
        
        // 重新加载阶段
        await this.loadTimeStages();
      } catch (error) {
        console.error('添加定时阶段失败:', error);
        this.$message.error('添加定时阶段失败');
      }
    },
    async addTime() {
        await addDuringTime(this.newStageForm);
    },
    // 应用批量定时到所有商品
    applyBatchTime() {
      this.$confirm('确定要将这个定时设置应用到所有商品吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.tableGoods.forEach(item => {
          item.startTime = this.batchTime.startTime;
          item.during = this.batchTime.during;
        });
        this.$message.success('批量定时设置已应用');
      });
    },
    
    // 清空批量定时设置
    clearBatchTime() {
      this.batchTime = {
        startTime: null,
        during: null
      };
    },
    
    // 复制阶段商品
    copyStageGoods(stage) {
      this.$confirm(`确定要复制${this.formatStageTime(stage)}的所有商品到当前页面吗?`, '提示', {
        type: 'warning'
      }).then(() => {
        this.$api.goods_GCList({
          data: {
            startTime: stage.startTime,
            during: stage.during,
            "pageModel.pageNo": 1,
            "pageModel.pageSize": this.pagination.size
          },
          success: res => {
            this.tableGoods = res.records;
            this.pagination.total = res.total;
            this.$message.success('商品复制成功');
          }
        });
      });
    },
    
    // 原有方法保持不变
    handleRemove(file, type) {
      let index;
      const arr = type == 'zt' ? this.mainFileList : this.nextFileList;
      index = arr.findIndex(f => f.url === file.url);
      if (type == 'zt') {
        if (index !== -1) {
          this.mainFileList.splice(index, 1);
          this.formAddGoods.headImg.splice(index, 1);
          this.hideMainUpload = false;
        }
      } else {
        if (index !== -1) {
          this.nextFileList.splice(index, 1);
          this.formAddGoods.imgList.splice(index, 1);
          this.hideNextUpload = false;
        }
      }
    },
    
    getBanjiaStatus(row) {
      if (!row.startTime || !row.during) {
        return '-';
      }
      
      const now = new Date();
      const startTime = new Date(row.startTime);
      const endTime = new Date(startTime.getTime() + row.during * 60 * 1000);
      
      if (now < startTime) {
        return '未开始';
      } else if (now >= startTime && now <= endTime) {
        return '进行中';
      } else {
        return '已结束';
      }
    },
    
    changePermission() {
      const userInfo = JSON.parse(localStorage.getItem('USER_INFO'));
      if (userInfo.roleId == 7) {
        this.showView = false;
        this.clearableStoreId = false;
        this.disabledStoreId = true;
        this.disabledCategory = false;
        this.wScreen.storeId = userInfo.storeId;
        this.getOptionsCategoryAll();
        this.getSupplyOptionsAll();
        this.getOptionsStore();
        this.getOptionsCategory(userInfo.storeId);
        this.getGoodsData(this.wScreen);
      } else {
        this.showView = true;
        this.getOptionsCategoryAll();
        this.getSupplyOptionsAll();
        this.getOptionsStore();
        this.getGoodsData(this.wScreen);
      }
    },
    
    getGoodsData(e) {
      this.$api.goods_GCList({
        data: e,
        success: res => {
          for (let id = 0; id < res.records.length; id++) {
            const element = res.records[id];
            let headImgArray = [];
            if (element.headImg) {
              const trimmedStr = element.headImg.slice(1, -1);
              if (trimmedStr) {
                headImgArray = trimmedStr.split(',');
              }
            }
            element.headImg = headImgArray || null;
          }
          this.tableGoods = res.records;
          this.pagination.total = res.total;
        }
      });
    },
    
    getOptionsStore() {
      let obj = {
        "pageModel.pageNo": 1,
        "pageModel.pageSize": 2000,
      };
      this.$api.store_list({
        data: obj,
        success: res => {
          let ary = [];
          for (let i = 0; i < res.records.length; i++) {
            const item = {
              label: res.records[i].storeName,
              value: res.records[i].id
            };
            ary.push(item);
          }
          this.optionsStore = ary;
        }
      });
    },
    
    getOptionsCategoryAll() {
      this.$api.goods_GCGetCategory({
        success: res => {
          let ary = []
          console.log(res);
          
          for (let i = 0; i < res.length; i++) {
            if (res.atype!=1) {
              
            }
            const item = {
              label: res[i].name,
              value: res[i].id
            }
            ary.push(item)
          }
          this.goodsCategory = ary
        }
      });
    },
    
    getSupplyOptionsAll() {
      getSupplyOptions().then(res => {
        let ary = [];
        for (let i = 0; i < res.length; i++) {
          const item = {
            label: res[i].name,
            value: res[i].id
          };
          ary.push(item);
        }
        this.goodsType = ary;
      });
    },
    
    getOptionsCategory(e) {
      let obj = { storeId: e };
      getClassify(obj).then(res => {
        let ary = [];
        for (let i = 0; i < res.length; i++) {
          const item = {
            label: res[i].name,
            value: res[i].id
          };
          ary.push(item);
        }
        this.optionsCategory = ary;
      });
    },
    
    changeInputSearch(e) {
      this.submitwScreen();
    },
    
    changeSupplyCategory(e) {
      this.onShowSkuList = true;
      if (e == 16) {
        this.visibleSupply = true;
        this.onShowSkuList = false;
      }
    },
    
    changeSelectStoreId(e) {
      if (!e && this.visibleAddGoods == false) {
        this.wScreen.categoryId = null;
        this.placeholderCategory = "请先选择门店";
        this.disabledCategory = true;
        this.submitwScreen();
      }
      
      if (!e && this.visibleAddGoods == true && this.visibleSupply) {
        this.formAddGoods.categoryId = null;
        this.placeholderCategory = "请先选择门店和商品类型";
        this.disabledCategory = true;
      }
      
      if (e && this.visibleAddGoods == false) {
        this.wScreen.categoryId = null;
        this.placeholderCategory = "请选择分类";
        this.disabledCategory = false;
        this.getOptionsCategory(e);
        this.submitwScreen();
      }
      
      if (e && this.visibleAddGoods == true && this.visibleSupply == false) {
        this.formAddGoods.categoryId = null;
        this.placeholderCategory = "只有堂食商品才需要分类";
        this.disabledCategory = true;
      }
      
      if (e && this.visibleAddGoods == true && this.visibleSupply == true) {
        this.formAddGoods.categoryId = null;
        this.placeholderCategory = "请选择分类";
        this.disabledCategory = false;
        this.getOptionsCategory(e);
      }
    },
    
    changeSelectCategory(e) {
      this.submitwScreen();
    },
    
    changeSelectState(e) {
      this.submitwScreen();
    },
    
    resetwScreen() {
      this.resetPagination();
      this.wScreen.search = null;
      this.wScreen.storeId = null;
      this.wScreen.categoryId = null;
      this.wScreen.state = null;
      this.wScreen["pageModel.pageNo"] = this.pagination.current;
      this.wScreen["pageModel.pageSize"] = this.pagination.size;
      this.placeholderCategory = "请先选择门店";
      this.disabledCategory = true;
      this.getGoodsData(this.wScreen);
    },
    
    submitwScreen() {
      if (this.visibleAddGoods == false) {
        this.resetPagination();
        this.wScreen["pageModel.pageNo"] = this.pagination.current;
        this.wScreen["pageModel.pageSize"] = this.pagination.size;
        this.wScreen.timeId=this.activeStage.id
        this.getGoodsData(this.wScreen);
      }
    },
    
    changeGoodsState(e) {
      this.$api.goods_GCUpdateState({
        data: {
          goodsId: e.row.id
        },
        success: res => {
          if (res) {
            this.$message.success('商品上架成功');
          } else {
            this.$message.info('商品已下架');
          }
        },
      });
    },
    
    changeIsGroupHotSale(e) {
      changeGroupHotSaleApi({ 
        goodsId: e.row.id, 
        isGroupHotSale: e.row.isGroupHotSale, 
        groupHotSaleNum: e.row.groupHotSaleNum 
      }).then(res => {
        console.log("限购状态修改", res);
      });
    },
    
    isImage(src) {
      
      if (!src) return false;
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const pureSrc = src.split('?')[0];
      const ext = '.' + pureSrc.split('.').pop().toLowerCase();
      
      return imageExtensions.includes(ext);
    },
    
    isVideo(src) {
      if (!src) return false;
      const videoExtensions = ['.mp4', '.avi', '.mkv', '.flv', '.webm'];
      const ext = '.' + src.split('.').pop().toLowerCase();
      return videoExtensions.includes(ext);
    },
    
    resetFormAddGoods() {
      this.hideMainUpload = false;
      this.hideNextUpload = false;
      this.mainFileList = [];
      this.nextFileList = [];
      this.unitNum = 1;
      this.goodsUnit = "份";
      this.formAddGoods = {
        storeId: null,
        categoryId: null,
        name: null,
        retailPrice: null,
        atype: null,
        sort: null,
        reorder: null,
        brand: null,
        salecomm: 0,
        discount: 0,
        noreason: 0,
        prem: 0,
        instantrefund: 0,
        unit: null,
        details: null,
        headImg: [],
        imgList: [],
        freight: 0,
        skuList: [{}],
        isExplosiveProducts: 0,
        isBanjiaProducts: 0,
        isVipFreeProducts: 0,
        topPrice: null,
        goodType: 2,
        decsPrice: null,
        startTime: null,
        during: null
      };
      this.commission = '';
      this.freightValue = "z";
      this.unnits = [
        {
          membershipPrice: 0,
          vipPrice: 0,
          qcPrice: 0,
          communityLeaderPrice: 0,
          price: 0,
          unitNum: "",
          stock: "",
          unit: "",
        }
      ];
    },
    
    addGoods() {
      console.log("添加商品", this.activeStage);
      
      if(this.activeStage==null||this.activeStage.id==null){
        this.$message.error('请先创建或选择左边时间段');
        return;
      }
      this.title = "添加商品";
      this.resetFormAddGoods();
      
      if (this.wScreen.storeId && this.wScreen.categoryId) {
        this.formAddGoods.storeId = this.wScreen.storeId;
        this.formAddGoods.categoryId = this.wScreen.categoryId;
      }
      
      if (this.wScreen.storeId && !this.wScreen.categoryId) {
        this.formAddGoods.storeId = this.wScreen.storeId;
        this.placeholderCategory = "请选择分类";
        this.disabledCategory = false;
      }
      
      if (!this.wScreen.storeId) {
        this.formAddGoods.categoryId = null;
        this.placeholderCategory = "请先选择门店";
        this.disabledCategory = true;
      }
      
      this.formAddGoods.unit = this.unitNum.toString() + this.goodsUnit.toString();
      this.visibleAddGoods = true;
    },
    
    updateGoods(e) {
      this.resetFormAddGoods();
      if (e.row.state == 1) {
        this.$message.error('请先下架商品再修改！');
        return;
      } else {
        this.title = "修改商品";
        goods_GCGetGoodsInfo({ goodsId: e.row.id }).then(res => {
          const formData = JSON.parse(JSON.stringify({
            id: res.id,
            atype: res.atype,
            categoryId: res.categoryId,
            details: res.details,
            name: res.name,
            retailPrice: res.retailPrice,
            sort: res.sort,
            reorder: res.reorder,
            brand: res.brand,
            salecomm: res.salecomm,
            discount: res.discount,
            noreason: res.noreason != null ? res.noreason : 0,
            prem: res.prem != null ? res.prem : 0,
            instantrefund: res.instantrefund != null ? res.instantrefund : 0,
            storeId: res.storeId,
            freight: res.freight,
            isExplosiveProducts: res.isExplosiveProducts ? 1 : 0,
            isBanjiaProducts: res.isBanjiaProducts ? 1 : 0,
            isVipFreeProducts: res.isVipFreeProducts ? 1 : 0,
            topPrice: res.topPrice,
            decsPrice: res.decsPrice,
            startTime: res.startTime,
            during: res.during,
            skuList: res.skuList || [],
            bidPrice:res.bidPrice
          }));
          
          this.formAddGoods = Object.assign({}, this.formAddGoods, formData);
          this.commission = res.commission || '';
          this.freightValue = res.identity || "z";
          
          if (res.skuList && res.skuList.length > 0) {
            this.unnits = res.skuList.map(item => {
              const unit = item.name.slice(-1);
              const unitNum = item.name.slice(0, -1);
              return {
                ...item,
                unit,
                unitNum
              };
            });
          }

          if (res.headImg) {
            const imgArray = res.headImg.slice(1, -1).split(',').map(url => url.trim());
            this.mainFileList = imgArray.map(url => ({ url }));
            this.formAddGoods.headImg = imgArray;
            this.hideMainUpload = imgArray.length >= this.limitMainImg;
          }

          if (res.imgList) {
            this.nextFileList = res.imgList.map(url => ({ url }));
            this.formAddGoods.imgList = res.imgList;
            this.hideNextUpload = res.imgList.length >= this.limitNextImg;
          }

          if (res.unit) {
            const m = res.unit.length;
            this.unitNum = res.unit.slice(0, m - 1);
            this.goodsUnit = res.unit.slice(m - 1, m);
            this.formAddGoods.unit = res.unit;
          }

          this.placeholderCategory = "请选择分类";
          this.disabledCategory = false;
          
          this.$nextTick(() => {
            this.$forceUpdate();
          });
          
          this.visibleAddGoods = true;
        });
      }
    },
    
    deleteGoods(e) {
      this.$confirm('确定要删除这个商品吗?', '提示', {
        type: 'warning'
      }).then(() => {
        goods_GCRemoveGoodsById({ goodsId: e.row.id }).then(res => {
          this.$message.success('删除成功！');
          this.submitwScreen();
        });
      });
    },
    
    getUploadUrl() { 
      return `${process.env.VUE_APP_URE}/file/uploadFile`; 
    },
    
    uploadBefore(file) {
      this.loading = true;
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isMp4 = file.type === 'video/mp4';
      
      if (!isJPG && !isPNG && !isMp4) {
        this.$message.error('上传文件只能是 JPG/PNG 图片或 MP4 视频格式!');
        return false;
      }
      return true;
    },
    
    uploadSuccessMain(file, fileList) {
      let obj = { url: file.data };
      this.mainFileList.push(obj);
      this.formAddGoods.headImg.push(file.data);
      if (this.mainFileList.length >= this.limitMainImg) {
        this.hideMainUpload = true;
      }
      this.$refs.mainUpload.clearFiles();
    },
    
    uploadSuccessNext(file, fileList) {
      let obj = { url: file.data };
      this.nextFileList.push(obj);
      this.formAddGoods.imgList.push(file.data);
      if (this.nextFileList.length >= this.limitNextImg) {
        this.hideNextUpload = true;
      }
      this.$refs.nextUpload.clearFiles();
    },
    
    uploadRemoveMain(file) {
      for (let i = 0; i < this.mainFileList.length; i++) {
        if (this.mainFileList[i].url == file.url) {
          this.mainFileList.splice(i, 1);
          this.formAddGoods.headImg.splice(i, 1);
          this.hideMainUpload = false;
        }
      }
    },
    
    uploadRemoveNext(file) {
      for (let i = 0; i < this.nextFileList.length; i++) {
        if (this.nextFileList[i].url == file.url) {
          this.nextFileList.splice(i, 1);
          for (let j = 0; j < this.formAddGoods.imgList.length; j++) {
            if (this.formAddGoods.imgList[j] == file.url) {
              this.formAddGoods.imgList.splice(j, 1);
            }
          }
          this.hideNextUpload = false;
        }
      }
    },
    
    submitAddGoods(formAddGoods) {
      console.log(this.formAddGoods.bidPrice);

      this.$refs[formAddGoods].validate((valid) => {
        const us = JSON.parse(JSON.stringify(this.unnits));
        const newus = us?.map((item) => {
          return {
            membershipPrice: Number(item.membershipPrice),
            price: Number(item.price),
            communityLeaderPrice: Number(item.communityLeaderPrice),
            vipPrice: Number(item.vipPrice),
            qcPrice: Number(item.qcPrice),
            name: item.unitNum + item.unit,
            stock: Number(item.stock)
          };
        });

        const obj = {
          ...this.formAddGoods,
          commission: this.commission,
          identity: this.freightValue,
          topPrice: this.formAddGoods.isExplosiveProducts ? parseFloat(this.formAddGoods.topPrice) : null,
          decsPrice: this.formAddGoods.isExplosiveProducts ? parseFloat(this.formAddGoods.decsPrice) : null,
          isExplosiveProducts: this.formAddGoods.isExplosiveProducts,
          isBanjiaProducts: this.formAddGoods.isBanjiaProducts,
          isVipFreeProducts: this.formAddGoods.isVipFreeProducts,
          goodType: 2,
          startTime: this.formAddGoods.startTime,
          during: this.formAddGoods.during,
          skuList: newus,
          timeId:this.activeStage.id,
          bidPrice:this.formAddGoods.bidPrice
        };

        
        if (valid) {
          if (!this.formAddGoods.id) {
            goods_GCAddGoods(obj).then(res => {
              this.$message.success('添加成功！');
              this.loadStageGoods()
              this.submitwScreen();
              this.visibleAddGoods = false;
            });
          } else {
            goods_GCEditGoods(obj).then(res => {
              this.$message.success('修改成功！');
              this.submitwScreen();
                            this.loadStageGoods()

              this.visibleAddGoods = false;
            });
          }
        } else {
          this.$message.error('请完善表单内容！');
          return false;
        }
      });
    },
    
    resetPagination() {
      this.pagination.current = 1;
    },
    
    changePaginationCurrent(e) {
      this.pagination.current = e;
      this.wScreen["pageModel.pageNo"] = this.pagination.current;
      this.wScreen["pageModel.pageSize"] = this.pagination.size;
      this.getGoodsData(this.wScreen);
    },
    
    changePaginationSize(e) {
      this.pagination.current = 1;
      this.pagination.size = e;
      this.wScreen["pageModel.pageNo"] = this.pagination.current;
      this.wScreen["pageModel.pageSize"] = this.pagination.size;
      this.getGoodsData(this.wScreen);
    },
    
    addUnit() {
      const obj = {
        membershipPrice: 0,
        vipPrice: 0,
        qcPrice: 0,
        communityLeaderPrice: 0,
        price: 0,
        stock: "",
        unitNum: "",
        unit: "",
      };
      const arr = JSON.parse(JSON.stringify(this.unnits));
      arr.push(obj);
      this.unnits = arr;
    },
    
    reduce(i) {
      const arr = JSON.parse(JSON.stringify(this.unnits));
      const result = arr.reduce((acc, item, idx) => {
        if (idx !== i) { 
          acc.push(item);
        }
        return acc;
      }, []);
      this.unnits = result;
    },
    
    handleVideoUpload() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'video/*';
      
      input.onchange = async () => {
        const file = input.files[0];
        if (!file) return;
        
        const validTypes = ['video/mp4', 'video/webm', 'video/ogg'];
        if (!validTypes.includes(file.type)) {
          this.$message.error('仅支持MP4/WebM/OGG格式视频');
          return;
        }
        
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('视频大小不能超过50MB');
          return;
        }
        
        const quill = this.$refs.quillEditor.quill;
        const range = quill.getSelection();
        const placeholderId = `video-${Date.now()}`;
        
        quill.insertEmbed(range.index, 'video', {
          id: placeholderId,
          url: 'about:blank'
        }, 'user');
        
        try {
          const loading = this.$loading({
            lock: true,
            text: '视频上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.7)'
          });
          
          const formData = new FormData();
          formData.append('file', file);
          
          const res = await pub_fileUpload_file(formData);
          loading.close();
          
          if (res) {
            this.replaceVideoPlaceholder(placeholderId, res);
            this.$message.success('视频上传成功');
          } else {
            throw new Error(res.message || '上传失败');
          }
        } catch (error) {
          this.$message.error(`视频上传失败: ${error.message}`);
          this.removeVideoPlaceholder(placeholderId);
        }
      };
      
      input.click();
    },
    
    replaceVideoPlaceholder(id, url) {
      const quill = this.$refs.quillEditor.quill;
      const length = quill.getLength();
      
      for (let i = length - 1; i >= 0; i--) {
        const ops = quill.getContents(i, 1).ops;
        if (ops[0]?.insert?.video?.id === id) {
          quill.deleteText(i, 1, 'silent');
          quill.insertEmbed(i, 'video', url, 'user');
          return true;
        }
      }
      
      quill.insertEmbed(length, 'video', url, 'user');
      return false;
    },
    
    removeVideoPlaceholder(id) {
      const quill = this.$refs.quillEditor.quill;
      const contents = quill.getContents();
      let position = 0;
      
      for (const op of contents.ops) {
        if (op.insert?.video?.id === id) {
          quill.deleteText(position, 1, 'user');
          return;
        }
        position += this.getOpLength(op);
      }
    },
    
    getOpLength(op) {
      if (op.insert) {
        if (typeof op.insert === 'string') {
          return op.insert.length;
        }
        return 1;
      }
      return 0;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.time-stage-bar {
  padding: 10px;
  background: #f5f7fa;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 20px;
  border-radius: 4px;
  
  .stage-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    
    .el-tag {
      cursor: pointer;
      transition: all 0.3s;
      padding: 0 10px;
      height: 32px;
      line-height: 30px;
      
      &:hover {
        opacity: 0.8;
      }
      
      .el-icon-copy-document {
        margin-left: 5px;
        font-size: 14px;
        
        &:hover {
          color: #409EFF;
        }
      }
    }
  }
}

.main-content {
  display: flex;
  flex: 1;
  gap: 20px;
}

.batch-time-setting {
  width: 300px;
  flex-shrink: 0;
  
  .time-card {
    height: 100%;
    
    /deep/ .el-card__body {
      padding: 20px;
    }
  }
}

.content-right {
  flex: 1;
  overflow: auto;
}

.wML-screen {
  display: block;
  width: 100%;
  user-select: none;
  margin-bottom: 20px;

  .wMLS-list {
    display: block;
    width: 100%;
  }
}

.wGoodsList-area {
  display: block;
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  .wGL-goods {
    display: block;
    width: 100%;

    .wGLG-table {
      display: block;
      width: 100%;
    }

    .wPagination {
      display: block;
      width: 100%;
      margin-top: 20px;
      text-align: center;
    }
  }
}

.unitBox {
  border: 1px solid #eeeeee;
  padding: 10px;
  margin-bottom: 20px;
  
  .unitTop {
    display: flex;
  }
  
  .unitBottom {
    display: flex;
    margin-top: 20px;
  }
  
  .pricebox {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .input {
    margin-right: 5px;
    width: 150px;
  }
  
  .inputprice {
    width: 86px;
  }
  
  .goodsItem {
    display: flex;
    align-items: center;
    
    .span {
      text-wrap: nowrap;
      margin-right: 5px;
      margin-left: 5px;
      color: red;
      font-weight: bold;
    }
    
    .spankc {
      font-weight: normal;
      color: #606266;
    }
  }
  
  .but {
    margin-left: 10px;
    background: #FF6321;
    color: #ffffff;
    height: 40px;
  }
  
  .butdel {
    background: #ffffff;
    color: #333333;
    border: 1px solid #DCDFE6;
  }
}

.addbutb {
  margin-left: 10px;
  background: #FF6321 !important;
  color: #ffffff !important;
  margin-top: 20px;
}

.custom-upload-item {
  height: 100% !important;
}

/deep/ .el-dialog__body {
  overflow-y: auto !important;
  //height: 820px !important;
  max-height: calc(100vh - 200px);
}

/deep/ .el-dialog {
  margin-top: 10vh !important;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  
  .el-dialog__body {
    flex: 1;
    overflow-y: auto;
  }
}

.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.preview-video {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.file-item {
  display: inline-block;
  margin: 5px;
}

.ql-editor {
  min-height: 100px;
}

.hide .el-upload--picture-card {
  display: none !important;
}

.ql-editor video {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px 0;
  background-color: #f5f5f5;
}

.ql-editor video[data-id] {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ddd;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-tag {
  margin-right: 5px;
}

.status-info {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

.specification .el-form-item__content {
  display: flex !important;
}

.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 8px 0;
  min-width: 120px;

  .context-menu-item {
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.3s;

    i {
      font-size: 14px;
      color: #606266;
    }

    span {
      font-size: 14px;
      color: #606266;
    }

    &:hover {
      background-color: #f5f7fa;

      i, span {
        color: #409EFF;
      }
    }
  }
}
</style>